'use client';

import { c as _c } from "react/compiler-runtime";
import { convictionFraction, useGetMarketField } from '@morfi/backend-sdk-v2/client';
import { useAuthoritativePaintedDisplayCandidate, usePaintedMarketShareStructure } from '@/components/chart/painted-market-share-display';
import { MarketOutcomesOverviewPanel, type MarketOutcomesOverviewPanelProps } from '@/components/market/market-outcomes-overview-panel';
import { useHeldWhile } from '@/hooks/market/use-held-while';
import { useChartSettingsStore } from '@/stores/chart-settings';
export function ConnectedMarketOutcomesOverviewPanel(t0) {
  const $ = _c(14);
  const {
    resolutionHolding: t1,
    ...props
  } = t0;
  const resolutionHolding = t1 === undefined ? false : t1;
  const selectedOutcomeIndices = useChartSettingsStore(state => state.outcomeFilters[props.marketPubkey]);
  const candleSelected = useChartSettingsStore(state_0 => state_0.selectedOutcome[props.marketPubkey]);
  const candleMode = useChartSettingsStore(_temp);
  let t2;
  if ($[0] !== candleMode || $[1] !== candleSelected || $[2] !== selectedOutcomeIndices) {
    t2 = candleMode ? [candleSelected ?? 0] : selectedOutcomeIndices ?? [];
    $[0] = candleMode;
    $[1] = candleSelected;
    $[2] = selectedOutcomeIndices;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const displayedSelection = t2;
  const authoritativeCandidate = useAuthoritativePaintedDisplayCandidate();
  const paintedStructure = usePaintedMarketShareStructure();
  const paintedActive = authoritativeCandidate;
  const outcomes = useHeldWhile(useGetMarketField({
    pubkey: props.marketPubkey
  }, "outcomes"), resolutionHolding);
  let t3;
  if ($[4] !== outcomes) {
    t3 = row => {
      const outcome = outcomes?.find(item => item.outcomeIndex === row.index);
      return outcome === undefined ? row : {
        ...row,
        conviction: convictionFraction(outcome.conviction)
      };
    };
    $[4] = outcomes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const rows = props.rows.map(t3);
  let t4;
  if ($[6] !== paintedActive || $[7] !== paintedStructure) {
    t4 = paintedActive ? {
      paintedDisplay: {
        outcomeOrder: paintedStructure.outcomeOrder
      }
    } : {};
    $[6] = paintedActive;
    $[7] = paintedStructure;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== displayedSelection || $[10] !== props || $[11] !== rows || $[12] !== t4) {
    t5 = <MarketOutcomesOverviewPanel {...props} rows={rows} selectedOutcomeIndices={displayedSelection} {...t4} />;
    $[9] = displayedSelection;
    $[10] = props;
    $[11] = rows;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(state_1) {
  return state_1.chartMode === "live" && state_1.renderMode === "candle";
}